import { CircleCheck } from "lucide-react";
import { useNavigate } from "react-router-dom";

const AddPermissionsSuccess = ({
  closeAddUserPermissionsSuccess,
  handleRefetchUsers,
}) => {
  const navigate = useNavigate();
  const handleClose = () => {
    handleRefetchUsers();
    closeAddUserPermissionsSuccess();
  };

  const handleLogout = () => {
    navigate("/");
  };
  return (
    <div
      onClick={(e) => {
        handleClose();
      }}
      className="fixed inset-0 bg-black/50 z-40 flex items-center justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[500px] h-[250px] flex flex-col justify-center items-center gap-[10px] rounded-[10px] p-[20px] relative bg-white"
      >
        <CircleCheck color="#00A676" />
        <p className="text-[#5C5C5C] text-[16px] font-semibold">
          Success! User Permissions Updated
        </p>
        <p className="text-[#5C5C5C] text-[16px] text-center font-semibold">
          The user’s permissions have been successfully updated. These changes
          take effect immediately and determine the actions the user can perform
          within the system.
        </p>
        <div className="flex items-center justify-center gap-[10px]">
          <button
            onClick={handleLogout}
            className="h-[35px] rounded-[30px] bg-[#ffffff] border border-[#000000] px-[20px] text-[#000000] font-medium text-[15px]"
          >
            Logout
          </button>
          <button
            onClick={handleClose}
            className="h-[35px] rounded-[30px] bg-[#F3F3F3] px-[20px] text-[#5C5C5C] font-medium text-[15px]"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddPermissionsSuccess;
